import React, { Fragment } from 'react';
import CountUp, { useCountUp } from 'react-countup';
import Header from '../../components/header/Header';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import Bg from '../../images/bg/page_bg01.jpg'
import CtaSection from '../../components/CtaSection/CtaSection';
import icon from '../../images/icon/dollar-icon.svg'
import sImg from '../../images/hero/cd-img.png'
import sImg2 from '../../images/shape/brd_shape.png'
import PricingSection from './Pricing';
import FaqSection from '../../components/FaqSection/FaqSection';

const PricingPage = (props) => {

    useCountUp({
        end: '56656',
        ref: 'counter',
        enableScrollSpy: true,
        scrollSpyDelay: 1000,
    });


    return (
        <Fragment>
            <div className='body_wrap sco_agency'>
                <Header />              
                <PricingSection/>
                <FaqSection />
                <CtaSection />
            </div>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default PricingPage;
